import React from 'react';
import PageHero from './componenets/PageHero';
import Reveal from './componenets/Reveal';

export const Goals = () => (
  <div className="site-page">
    <PageHero eyebrow="Garden of Peace" title="Project Progress and Goals" description="Current project milestones and remaining work." image="/images/HomeSlider_6.jpg" compact />
    <section className="site-section site-section--sage"><Reveal className="site-container document-viewer"><img src="/images/UpdatedProgressDec.png" alt="Garden of Peace progress and goals" /></Reveal></section>
  </div>
);
